module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp2_0.d0b11d31.png";